import Button from '../base/Button';

export default function Header() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">
              <span style={{ fontFamily: '"Pacifico", serif' }}>Patrick Segers</span>
            </h1>
            <span className="ml-3 text-sm text-gray-600 hidden sm:block">
              Investigação Empresarial
            </span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#servicos" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              Serviços
            </a>
            <a href="#como-trabalhamos" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              Como Trabalhamos
            </a>
            <a href="#sobre" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              Sobre
            </a>
            <a 
              href="https://wa.me/5511993706525" 
              target="_blank" 
              rel="nofollow"
              className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>WhatsApp</span>
            </a>
          </nav>
          
          <div className="md:hidden">
            <Button onClick={scrollToContact} size="sm">
              Contato
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
